export default {
  '子品牌名称': {
    zh: '子品牌名称',
    en: 'Sub Brand Name',
    ar: 'اسم العلامة التجارية الفرعية',
    fa: 'نام تجاری فرعی',
    pt: 'Nome da Submarca'
  },
  '状态': {
    zh: '状态',
    en: 'State',
    ar: 'حالة',
    fa: 'دولت',
    pt: 'Estado'
  },
  '片源语言': {
    zh: '片源语言',
    en: 'Language',
    ar: 'اللغة المصدر للجهاز اللوحي',
    fa: 'زبان منبع قرص',
    pt: 'Linguagem'
  },
  '协议': {
    zh: '协议',
    en: 'Agreement',
    ar: 'اتفاق',
    fa: 'توافق',
    pt: 'Protocolo'
  },
  '入口地址': {
    zh: '入口地址',
    en: 'Entrance Address',
    ar: 'عنوان المدخل',
    fa: 'آدرس ورودی',
    pt: 'Endereço Entrada'
  },
  '鉴权方式': {
    zh: '鉴权方式',
    en: 'Authentication Method',
    ar: 'طريقة المصادقة',
    fa: 'روش احراز هویت',
    pt: 'Método Autenticação'
  },
  '运营模块': {
    zh: '运营模块',
    en: 'Operations Module',
    ar: 'وحدة العمليات',
    fa: 'ماژول عملیات',
    pt: 'Módulo Operação'
  },
  '选择型号': {
    zh: '选择型号',
    en: 'Select Model',
    ar: 'اختر النموذج',
    fa: 'مدل را انتخاب کنید',
    pt: 'Escolha Modelo'
  },
  '排序': {
    zh: '排序',
    en: 'Sort',
    ar: 'صنف',
    fa: 'نوع',
    pt: 'Ordenar'
  },
  '剧集试看集数': {
    zh: '剧集试看集数',
    en: 'TV Shows Preview Num',
    ar: 'حلقات معاينة الحلقة',
    fa: 'قسمت های پیش نمایش قسمت',
    pt: 'Número Teste'
  },
  '单片试看时间': {
    zh: '单片试看时间',
    en: 'Movie Trial Time',
    ar: 'وقت تجريبي من قطعة واحدة',
    fa: 'زمان محاکمه تک تکه',
    pt: 'Duração Teste'
  },
  '备注': {
    zh: '备注',
    en: 'Remark',
    ar: 'كلام',
    fa: 'سخن گفتن',
    pt: 'Notas'
  },
  '内容列表': {
    zh: '内容列表',
    en: 'Table of Contents',
    ar: 'جدول المحتويات',
    fa: 'جدول مطالب',
    pt: 'Lista de Conteúdos'
  },
  '频道分类': {
    zh: '频道分类',
    en: 'Channel Category',
    ar: 'تصنيف القنوات',
    fa: 'طبقه بندی کانال',
    pt: 'Classificação dos Canais'
  },
  '节目数量更新': {
    zh: '节目数量更新',
    en: 'Programs Num Updated',
    ar: 'يتم تحديث عدد البرامج',
    fa: 'تعداد برنامه ها به روز می شود',
    pt: 'Número de Programas Atualizando'
  },
  '自动排序': {
    zh: '自动排序',
    en: 'Auto Sorting',
    ar: 'الفرز التلقائي',
    fa: 'مرتب سازی خودکار',
    pt: 'Ordenação Automática'
  },
  '添加子分类': {
    zh: '添加子分类',
    en: 'Add Subcategories',
    ar: 'إضافة فئات فرعية',
    fa: 'اضافه کردن زیردسته ها',
    pt: 'Adicionar Subcategoria'
  },
  '分类名称': {
    zh: '分类名称',
    en: 'Category Name',
    ar: 'اسم التصنيف',
    fa: 'نام تاکسونومی',
    pt: 'Nome da Categoria'
  },
  '节目总数': {
    zh: '节目总数',
    en: 'Total Num',
    ar: 'إجمالي عدد البرامج',
    fa: 'تعداد کل برنامه ها',
    pt: 'Número Total Programas'
  },
  '描述': {
    zh: '描述',
    en: 'Description',
    ar: 'وصف',
    fa: 'توضیحات',
    pt: 'Descrição'
  },
  '频道内容': {
    zh: '频道内容',
    en: 'Channel Content',
    ar: 'محتوى القناة',
    fa: 'محتوای کانال',
    pt: 'Conteúdo do Canal'
  },
  '添加频道': {
    zh: '添加频道',
    en: 'Add Channel',
    ar: 'إضافة قناة',
    fa: 'افزودن کانال',
    pt: 'Adicionar Canal'
  },
  '频道号': {
    zh: '频道号',
    en: 'Channel Number',
    ar: 'رقم القناة',
    fa: 'شماره کانال',
    pt: 'Número do Canal'
  },
  '频道名称': {
    zh: '频道名称',
    en: 'Channel Name',
    ar: 'اسم القناة',
    fa: 'نام کانال',
    pt: 'Nome do Canal'
  },
  '别名': {
    zh: '别名',
    en: 'Alias',
    ar: 'اسم مستعار',
    fa: 'نام مستعار',
    pt: 'Alias'
  },
  '上线状态': {
    zh: '上线状态',
    en: 'Online Status',
    ar: 'حالة الخط العلوي',
    fa: 'وضعیت بالا خط',
    pt: 'Estado Online'
  },
  '分类': {
    zh: '分类',
    en: 'Category',
    ar: 'تصنيف',
    fa: 'تصنیف',
    pt: 'Taxonomia'
  },
  '导入频道': {
    zh: '导入频道',
    en: 'Import Channels',
    ar: 'استيراد القنوات',
    fa: 'کانال های واردات',
    pt: 'Importação de Canais'
  },
  '按名称排序': {
    zh: '按名称排序',
    en: 'Sort by Name',
    ar: 'فرز حسب الاسم',
    fa: 'مرتب سازی بر اساس نام',
    pt: 'Classificar por Nome'
  },
  '显示编号': {
    zh: '显示编号',
    en: 'Logical Channel Number',
    ar: 'يعرض الرقم',
    fa: 'عدد را نمایش می دهد',
    pt: 'Número de Exibição'
  },
  /** 前面多一个空格用于显示简写 */
  ' 显示编号': {
    zh: ' 显示编号',
    en: 'LCN',
    ar: 'يعرض الرقم',
    fa: 'عدد را نمایش می دهد',
    pt: 'LCN'
  },
  '内容类型': {
    zh: '内容类型',
    en: 'Content Type',
    ar: 'نوع المحتوى',
    fa: 'نوع محتوا',
    pt: 'Tipo de Conteúdo'
  },
  '添加分类': {
    zh: '添加分类',
    en: 'Add Category',
    ar: 'إضافة تصنيف',
    fa: 'اضافه کردن گروه',
    pt: 'Adicionar Categoria'
  },
  'Edit Category': {
    zh: '修改分类',
    en: 'Edit Category',
    ar: 'تعديل التصنيف',
    fa: 'تغییر گروهی',
    pt: 'Modificar Categoria'
  },
  '上级分类': {
    zh: '上级分类',
    en: 'Parent Category',
    ar: 'تصنيف الوالدين',
    fa: 'طبقه بندی والدین',
    pt: 'Categoria Pai'
  },
  '成人分类': {
    zh: '成人分类',
    en: 'Adult Category',
    ar: 'تصنيف البالغين',
    fa: 'طبقه بندی بزرگسالان',
    pt: 'Classificação de Adultos'
  },
  '点播分类': {
    zh: '点播分类',
    en: 'On Demand Category',
    ar: 'التصنيف حسب الطلب',
    fa: 'طبقه بندی بر روی تقاضا',
    pt: 'Classificação a Pedido'
  },
  '添加点播': {
    zh: '添加点播',
    en: 'Add on Demand',
    ar: 'إضافة حسب الطلب',
    fa: 'اضافه کردن بر روی تقاضا',
    pt: 'Adicione Demanda'
  },
  '添加系列': {
    zh: '添加系列',
    en: 'Add Movie Sets',
    ar: 'إضافة سلسلة',
    fa: 'اضافه کردن یک سری',
    pt: 'Adicione Série'
  },
  '影片付费编辑': {
    zh: '影片付费编辑',
    en: 'Paid Editing of Movies',
    ar: 'التحرير المدفوع للأفلام',
    fa: 'ویرایش پرداخت شده از فیلم',
    pt: 'Edição de Filmes Pagos'
  },
  '导入电影': {
    zh: '导入电影',
    en: 'Import Movies ',
    ar: 'استيراد الأفلام',
    fa: 'واردات فیلم',
    pt: 'Importar Filmes'
  },
  '导入连续剧': {
    zh: '导入连续剧',
    en: 'Import Series',
    ar: 'استيراد السلسلة',
    fa: 'وارد کردن سری',
    pt: 'Série Importação'
  },
  'IMDB ID': {
    zh: 'IMDB ID',
    en: 'IMDB ID',
    ar: 'IMDB ID',
    fa: 'IMDB ID',
    pt: 'IMDB ID'
  },
  '付费形式': {
    zh: '付费形式',
    en: 'Paid Form',
    ar: 'نموذج مدفوع',
    fa: 'فرم پرداخت شده',
    pt: 'Método Pagamento'
  },
  '分辨率': {
    zh: '分辨率',
    en: 'Resolution',
    ar: 'دقة',
    fa: 'وضوح',
    pt: 'Potência de Resolução'
  },
  '数据列表': {
    zh: '数据列表',
    en: 'Data List',
    ar: 'قائمة بالبيانات',
    fa: 'فهرستی از داده ها',
    pt: 'Lista de Dados'
  },
  '运营方案': {
    zh: '运营方案',
    en: 'Operational Plan',
    ar: 'السيناريوهات التشغيلية',
    fa: 'سناریوهای عملیاتی',
    pt: 'Plano Operacional'
  },
  '型号': {
    zh: '型号',
    en: 'Model',
    ar: 'نموذج',
    fa: 'مدل',
    pt: 'Modelo'
  },
  '方案名称': {
    zh: '方案名称',
    en: 'Plan Name',
    ar: 'اسم السيناريو',
    fa: 'نام سناریو',
    pt: 'Nome Programa'
  },
  '运营方案名称': {
    zh: '运营方案名称',
    en: 'Operation Plan Name',
    ar: 'اسم العملية',
    fa: 'نام عملیات',
    pt: 'Nome do Plano Operação'
  },
  '主题数量': {
    zh: '主题数量',
    en: 'Number of Topics',
    ar: 'عدد المواضيع',
    fa: 'تعداد موضوعات',
    pt: 'Número de Temas'
  },
  '选择Model': {
    zh: '选择Model',
    en: 'Select Model',
    ar: 'اختر الموديل',
    fa: 'انتخاب مدل',
    pt: 'Selecionar Modelo'
  },
  '暂无数据': {
    zh: '暂无数据',
    en: 'No Data',
    ar: 'لا توجد بيانات حتى الآن',
    fa: 'هنوز هیچ داده ای',
    pt: 'Sem Dados'
  },
  '已选数据': {
    zh: '已选数据',
    en: 'Selected Data',
    ar: 'بيانات مختارة',
    fa: 'داده های انتخاب شده',
    pt: 'Dados Seleccionados'
  },
  '选择品牌': {
    zh: '选择品牌',
    en: 'Select Brand',
    ar: 'اختر علامة تجارية',
    fa: 'یک برند را انتخاب کنید',
    pt: 'Selecionar Marca'
  },
  '选择平台': {
    zh: '选择平台',
    en: 'Select Platform',
    ar: 'رصيف',
    fa: 'بستر',
    pt: 'Selecionar Plataforma'
  },
  '本页全选': {
    zh: '本页全选',
    en: 'Select all on this page',
    ar: 'حدد الكل في هذه الصفحة',
    fa: 'همه را در این صفحه انتخاب کنید',
    pt: 'Selecionar tudo nesta página'
  },
  '运行': {
    zh: '运行',
    en: 'Running',
    ar: 'ركض',
    fa: 'اجرا',
    pt: 'Correr'
  },
  '停运': {
    zh: '停运',
    en: 'Decommissioning',
    ar: 'سحب',
    fa: 'از کار انداختن',
    pt: 'Interrupção'
  },
  '主题管理': {
    zh: '主题管理',
    en: 'Topic Management',
    ar: 'موضوع الإدارة ',
    fa: 'مدیریت عنوان',
    pt: 'Gestão de Temas'
  },
  '新增主题': {
    zh: '新增主题',
    en: 'New Topic',
    ar: 'إضافة موضوع ',
    fa: 'موضوع جدید',
    pt: 'Adicionar Tópico'
  },
  '主题名称': {
    zh: '主题名称',
    en: 'Topic Name',
    ar: 'اسم الموضوع ',
    fa: 'نام عنوان',
    pt: 'Nome do Tópico'
  },
  '主题类型': {
    zh: '主题类型',
    en: 'Topic Type',
    ar: 'نوع الموضوع',
    fa: 'نوع موضوع',
    pt: 'Tipo de Tema'
  },
  '推荐位模板': {
    zh: '推荐位模板',
    en: 'Recommended Bit Template',
    ar: 'أوصت بت قالب',
    fa: 'قالب های بیتی توصیه شده',
    pt: 'Modelo Posição Recomendado'
  },
  '推荐位数量': {
    zh: '推荐位数量',
    en: 'Number of Recommended',
    ar: 'عدد البتات الموصى بها',
    fa: 'تعداد بیت های توصیه شده',
    pt: 'Número Recomendado '
  },
  '推荐位名称': {
    zh: '推荐位名称',
    en: 'Template Name',
    ar: ' أوصى اسم القالب ',
    fa: 'نام قالب پیشنهاد',
    pt: 'Nome do Modelo'
  },
  '推荐位尺寸': {
    zh: '推荐位尺寸',
    en: 'Recommended Bit Size',
    ar: ' أوصت بت حجم ',
    fa: 'اندازۀ بیت پیشنهاد',
    pt: 'Tamanho Recomendado da Posição'
  },
  '分类名称已经存在': {
    zh: '分类名称已经存在',
    en: 'The taxonomy name already exists.',
    ar: '.اسم التصنيف موجود بالفعل',
    fa: '.نام taxonomy در حال حاضر وجود دارد',
    pt: 'O nome da classificação já existe.'
  },
  '主题名称已经存在': {
    zh: '主题名称已经存在',
    en: 'Topic name already exists.',
    ar: '.اسم الموضوع موجود بالفعل',
    fa: '.نام عنوان قبلا وجود دارد',
    pt: 'O nome do tema já existe.'
  },
  '已经跟运营方案绑定，不允许删除': {
    zh: '已经跟运营方案绑定，不允许删除',
    en: 'It has been bound to the operation scheme and cannot be deleted.',
    ar: '.بالفعل مع نظام التشغيل ، لا يسمح بحذف',
    fa: '.آن به برنامه عملیات مرتبط شده و نمی‌تواند حذف شود',
    pt: 'Já vinculado ao plano de operação, exclusão não permitida.'
  },
  '运营方案名称已经存在': {
    zh: '运营方案名称已经存在',
    en: 'The operation scheme name already exists',
    ar: 'اسم الحل موجود بالفعل',
    fa: 'نام برنامه عملیات قبلا وجود دارد',
    pt: 'O nome do plano de operação já existe'
  },
  '运营方案不允许删': {
    zh: '运营方案不允许删',
    en: 'Operation scheme cannot be deleted',
    ar: 'برنامج التشغيل لا يسمح بحذف',
    fa: 'برنامه عملیات نمی‌تواند حذف شود',
    pt: 'Os planos de operação não podem ser excluídos'
  },
  '请选择主题类型': {
    zh: '请选择主题类型',
    en: 'Please select a topic type',
    ar: 'الرجاء اختيار نوع الموضوع',
    fa: 'لطفا نوع تم را انتخاب کنید',
    pt: 'Selecione um tipo de tópico'
  },
  '请填写主题名称': {
    zh: '请填写主题名称',
    en: 'Please input the topic name',
    ar: 'يرجى ملء اسم الموضوع',
    fa: 'لطفا نام موضوع را پر کنید',
    pt: 'Por favor preencha o nome do tópico'
  },
  '请选择推荐位模板': {
    zh: '请选择推荐位模板',
    en: 'Please select the recommended template',
    ar: 'الرجاء اختيار قالب بت الموصى بها',
    fa: 'لطفاً قالب موقعیت پیشنهاد را انتخاب کنید',
    pt: 'Selecione um modelo de bit recomendado'
  },
  '固定': {
    zh: '固定',
    en: 'Fixed',
    ar: 'ثابت .',
    fa: 'ثابت',
    pt: 'Fixo'
  },
  '运营': {
    zh: '运营',
    en: 'Operation',
    ar: 'العمليات',
    fa: 'عمل کردن',
    pt: 'Operações'
  },
  '新增方案': {
    zh: '新增方案',
    en: 'New Plan',
    ar: 'إضافة مخطط',
    fa: 'نقشه جدید',
    pt: 'Novo Plano'
  },
  '关联主题': {
    zh: '关联主题',
    en: 'Associated Topics',
    ar: 'المواضيع ذات الصلة',
    fa: 'موضوع مربوط به',
    pt: 'Tema Associado'
  },
  '请输入方案名称': {
    zh: '请输入方案名称',
    en: 'Please input the plan name',
    ar: 'يرجى ملء اسم البرنامج',
    fa: 'لطفا نام برنامه را پر کنید',
    pt: 'Insira o nome do plano'
  },
  '选择主题': {
    zh: '选择主题',
    en: 'Select Topic',
    ar: 'اختيار الموضوع',
    fa: 'برگزیدن عنوان',
    pt: 'Selecione o Tema'
  },
  '关键字': {
    zh: '关键字',
    en: 'Keyword',
    ar: 'الكلمه - المفتاح',
    fa: 'کلید کلید',
    pt: 'Palavra-chave'
  },
  '请输入关键字': {
    zh: '请输入关键字',
    en: 'Please input the keyword',
    ar: 'من فضلك أدخل المفتاح',
    fa: 'لطفاً کلمات کلید وارد کنید',
    pt: 'Por favor insira palavras-chave'
  },
  '请选择主题': {
    zh: '请选择主题',
    en: 'Please select a topic',
    ar: 'الرجاء اختيار الموضوع',
    fa: 'لطفا یک موضوع را انتخاب کنید',
    pt: 'Seleccione por favor um tema'
  },
  '待执行': {
    zh: '待执行',
    en: 'Unexecuted',
    ar: 'لم تنفذ',
    fa: 'عملکرد نشده',
    pt: 'Para ser Executado'
  },
  '执行中': {
    zh: '执行中',
    en: 'Executing',
    ar: 'في التنفيذ',
    fa: 'تحت عملکرد',
    pt: 'A Executar'
  },
  '结束': {
    zh: '结束',
    en: 'End',
    ar: 'نهاية',
    fa: 'پایان',
    pt: 'Finish'
  },
  '品牌图标': {
    zh: '品牌图标',
    en: 'Brand Icon',
    ar: 'أيقونة العلامة التجارية',
    fa: 'نماد برند',
    pt: 'Ícone da Marca'
  },
  '分钟': {
    zh: '分钟',
    en: 'Minute',
    ar: 'دقيقة',
    fa: 'دقیقه‌',
    pt: 'Minuto'
  },
  '集数': {
    zh: '集数',
    en: 'Episodes',
    ar: 'رقم',
    fa: 'شماره',
    pt: 'Número Episódios'
  },
  '请输入子品牌名称': {
    zh: '请输入子品牌名称',
    en: 'Please input the sub brand name',
    ar: 'من فضلك أدخل اسم العلامة التجارية الفرعية',
    fa: 'لطفا نام تجاری فرعی را وارد کنید',
    pt: 'Por favor, insira o nome da sub marca'
  },
  '请输入排序': {
    zh: '请输入排序',
    en: 'Please input the sequence',
    ar: 'من فضلك أدخل الرقم المسلسل',
    fa: 'لطفا شماره سریال را وارد کنید',
    pt: 'Por favor insira a sequência'
  },
  '我的子品牌': {
    zh: '我的子品牌',
    en: 'My Sub Brand',
    ar: 'بلدي العلامة التجارية الفرعية',
    fa: 'زير برند من',
    pt: 'Minha Sub Brand'
  },
  '系列片': {
    zh: '系列片',
    en: 'Movie Sets',
    ar: 'مسلسل',
    fa: 'فیلم سری',
    pt: 'Series'
  },
  '内容名称': {
    zh: '内容名称',
    en: 'Content Name',
    ar: 'اسم المحتوى',
    fa: 'نام محتویات',
    pt: 'Nome do Conteúdo'
  },
  '请选择平台': {
    zh: '请选择平台',
    en: 'Please select platform',
    ar: 'الرجاء اختيار منصة',
    fa: 'لطفا یک پلتفرم انتخاب کنید',
    pt: 'Por favor, seleccione a plataforma'
  },
  '请选择运营模块': {
    zh: '请选择运营模块',
    en: 'Please select operation module',
    ar: 'الرجاء تحديد وحدة التشغيل',
    fa: 'لطفاً ماژول عملیاتی را انتخاب کنید',
    pt: 'Selecione o módulo de operação'
  },
  '请选择状态': {
    zh: '请选择状态',
    en: 'Please select state',
    ar: 'اختر من فضلك حالة',
    fa: 'لطفا وضعیت را انتخاب کنید',
    pt: 'Selecione Status'
  },
  '专题': {
    zh: '专题',
    en: 'Special ',
    ar: 'موضوع خاص',
    fa: 'موضوع خاص',
    pt: 'Tópicos'
  },
  '首个': {
    zh: '首个',
    en: 'First',
    ar: 'أول',
    fa: 'اولین',
    pt: 'Primeiro'
  },
  '最后': {
    zh: '最后',
    en: 'Last',
    ar: 'فى الاخير',
    fa: 'آخرین',
    pt: 'Durar'
  },
  'VIP内容': {
    zh: 'VIP内容',
    en: 'VIP Content',
    ar: 'محتوای VIP',
    fa: 'محتوای VIP',
    pt: 'Conteúdo VIP'
  },
  '付费单片': {
    zh: '付费单片',
    en: 'Paid Monolithic',
    ar: 'فيلم واحد مدفوع الأجر',
    fa: 'فیلم پرداخت',
    pt: 'Ficha Única Paga'
  },
  '免费内容': {
    zh: '免费内容',
    en: 'Free Content',
    ar: 'محتوى مجاني',
    fa: 'محتوای رایگان',
    pt: 'Conteúdo Gratuito'
  },
  '按名称排序成功': {
    zh: '按名称排序成功',
    en: 'Sort by name successfully.',
    ar: '.فرز بنجاح',
    fa: '.با موفقیت با نام مرتب شوید',
    pt: 'Classificar por nome com sucesso'
  },
  '按名称排序失败': {
    zh: '按名称排序失败',
    en: 'Sort by name failed.',
    ar: '.فرز الفشل',
    fa: '.تنظیم شکست خورد',
    pt: 'Classificação pelo nome fail'
  },
  '操作后内容列表会按名称字母重新排序，确认操作吗?': {
    zh: '操作后内容列表会按名称字母重新排序，确认操作吗?',
    en: 'Are you sure to sort all?',
    ar: 'إعادة ترتيب؟',
    fa: 'تنظیم مجدد؟',
    pt: 'Após a operação, a lista de conteúdo será reordenada por nome alfabético. Você confirma a operação?'
  },
  '节目数量更新成功': {
    zh: '节目数量更新成功',
    en: 'Program count update successfully.',
    ar: '.عدد البرامج التي تم تحديثها بنجاح',
    fa: '.به روزرسانی کامل شد',
    pt: 'Número do programa atualizado com sucesso'
  },
  '节目数量更新失败': {
    zh: '节目数量更新失败',
    en: 'Program count update failed.',
    ar: '.فشل تحديث البرنامج عدد',
    fa: '.مقدار برنامه به روز نشد',
    pt: 'Falha na atualização do número do programa'
  },
  '选中系列片内容不支持付费编辑': {
    zh: '选中系列片内容不支持付费编辑',
    en: 'The selected movie sets does not support paid editing.',
    ar: '.مسلسل لا تدعم التحرير المدفوع',
    fa: '.فیلم سری از ویرایش پرداخت شده پشتیبانی نکنید',
    pt: 'O conteúdo da série selecionada não suporta edição paga'
  },
  '选中剧集内容不支持设置为付费单片': {
    zh: '选中剧集内容不支持设置为付费单片',
    en: 'The selected TV Shows does not support paid editing.',
    ar: 'اختيار الدراما غير معتمد .',
    fa: 'نمایش تلویزیون برگزیده پشتیبانی نمی‌شود.',
    pt: 'O conteúdo do episódio selecionado não suporta configurá-lo como um único episódio pago'
  },
  '免费': {
    zh: '免费',
    en: 'Free Content',
    ar: 'محتوى مجاني',
    fa: 'محتوای رایگان',
    pt: 'Conteúdo Grátis'
  },
  '确定修改所选数据吗?': {
    zh: '确定修改所选数据吗?',
    en: 'Are you sure to modify the selected data?',
    ar: 'هل أنت متأكد من أنك تريد تعديل البيانات المختارة ؟',
    fa: 'مطمئنی که داده‌های برگزیده را تغییر دهید؟',
    pt: 'Tem certeza de que deseja modificar os dados selecionados?'
  },
  '请选择至少一条数据': {
    zh: '请选择至少一条数据',
    en: 'Please select at least one piece of data.',
    ar: '.الرجاء اختيار واحد على الأقل من البيانات',
    fa: '.لطفاً حداقل یک داده را انتخاب کنید',
    pt: 'Selecione pelo menos um dado'
  },
  '推荐管理': {
    zh: '推荐管理',
    en: 'Recommend Manage',
    ar: 'إدارة التوصية',
    fa: 'مدیریت ارجاع',
    pt: 'Gestão da Recomendação'
  },
  '需将分类中的内容清空再删除': {
    zh: '需将分类中的内容清空再删除',
    en: 'The content in the category needs to be cleared and then deleted.',
    ar: '.يجب مسح المحتوى الموجود في الفئة ثم حذفه',
    fa: '.قبل از حذف باید محتوای موجود در طبقه بندی را پاک کنید',
    pt: 'É necessário limpar o conteúdo da categoria e depois excluí-lo.'
  },
  // '该子品牌运营中,无法删除': {
  //   zh: '该子品牌运营中,无法删除',
  //   en: 'This sub brand is in operation and cannot be deleted.',
  //   ar: '.في تشغيل العلامة التجارية الفرعية ، حذف فشل',
  //   fa: '.برند در حال کار ، شکست را حذف کنید',
  //   pt: 'Na operação da sub -marca, ele não pode ser excluído'
  // },
  '请先删除主品牌下的子品牌，再操作删除': {
    zh: '请先删除主品牌下的子品牌，再操作删除',
    en: 'Please delete the sub brands under the main brand before proceeding with deletion.',
    ar: '.يرجى حذف العلامة التجارية الفرعية أولاً',
    fa: '.لطفاً ابتدا زیربند را حذف کنید',
    pt: 'Exclua a sub -marca sob a marca principal primeiro e depois opere para excluir.'
  },
  '请先停运主品牌，再操作删除': {
    zh: '请先停运主品牌，再操作删除',
    en: 'Please stop the main brand before deleting it.',
    ar: 'يرجى إيقاف تشغيل العلامة التجارية الرئيسية الأولى.',
    fa: 'لطفا اول برند اصلی رو متوقف کنید.',
    pt: 'Pare de usar a marca principal primeiro e depois exclua-a.'
  },
  '请先停运子品牌，再操作删除': {
    zh: '请先停运子品牌，再操作删除',
    en: 'Please stop the sub brand before deleting it.',
    ar: 'يرجى إيقاف تشغيل العلامة التجارية الفرعية الأولى.',
    fa: 'لطفاً ابتدا زیربند را خاموش کنید.',
    pt: 'Pare de operar a submarca primeiro e depois exclua-a.'
  },
  '确认将子品牌删除吗?': {
    zh: '确认将子品牌删除吗?',
    en: 'Are you sure to delete this sub brand?',
    ar: 'هل أنت متأكد من أنك تريد حذف هذه العلامة التجارية الفرعية ؟',
    fa: 'مطمئني اين زير برند رو پاک کني؟',
    pt: 'Você tem certeza de excluir a sub marca?'
  },
  '确认将主品牌删除吗?': {
    zh: '确认将主品牌删除吗?',
    en: 'Are you sure to delete this main brand?',
    ar: 'هل أنت متأكد من أنك تريد حذف العلامة التجارية الرئيسية ؟',
    fa: 'مطمئني برند اصلي رو پاک کني؟',
    pt: 'Você tem certeza de excluir a marca principal?'
  },
  '推荐位类型': {
    zh: '推荐位类型',
    en: 'Recommended Type',
    ar: 'أوصت بت نوع',
    fa: 'نوع توصیه شده',
    pt: 'Tipos de Bits Recomendados'
  },
  'manual': {
    zh: '手动推荐',
    en: 'Manual',
    ar: 'Manual',
    fa: 'Manual',
    pt: 'Manual'
  },
  'fixed-by-topic': {
    zh: '固定分类-by topic',
    en: 'Fixed By Topic',
    ar: 'Fixed By Topic',
    fa: 'Fixed By Topic',
    pt: 'Fixed By Topic'
  },
  'fixed-all': {
    zh: '固定分类-all',
    en: 'All',
    ar: 'All',
    fa: 'All',
    pt: 'All'
  },
  'manual-by-topic': {
    zh: '手动推荐-topic',
    en: 'Manual By Topic',
    ar: 'Manual By Topic',
    fa: 'Manual By Topic',
    pt: 'Manual By Topic'
  },
  'UI风格': {
    zh: 'UI风格',
    en: 'UI Style',
    ar: 'نمط واجهة المستخدم',
    fa: 'سبک UI',
    pt: 'Estilo da IU'
  },
  'UI方向': {
    zh: 'UI方向',
    en: 'UI Direction',
    ar: 'اتجاه واجهة المستخدم',
    fa: 'جهت کار UI',
    pt: 'Direção UI'
  },
  '推荐位尺寸图片上传提示': {
    zh: '温馨提示：推荐位尺寸{size} 图片大小建议在500KB以内。',
    en: 'Warm tip: The recommended bit size {size} is recommended to be within 500KB.',
    ar: 'نصيحة : حجم الصورة الموصى بها { size } kb 500 كيلو بايت.',
    fa: 'یادآوری: اندازه بیت توصیه شده {اندازه} اندازه تصویر بین 500 کیلوبایت توصیه می شود.',
    pt: 'Lembrete: Tamanho de bits recomendado {size} O tamanho da imagem recomendado é de 500 KB.'
  },
  '付费类别': {
    zh: '付费类别',
    en: 'Payment Method',
    ar: 'فئة الدفع',
    fa: 'نوع پرداخت',
    pt: 'Categoria Paga'
  },
  '推荐图': {
    zh: '推荐图',
    en: 'Logo',
    ar: 'صور',
    fa: 'تصویر',
    pt: 'Logotipo'
  },
  '添加子推荐位': {
    zh: '添加子推荐位',
    en: 'Add Region',
    ar: 'إضافة منطقة',
    fa: 'افزودن منطقه',
    pt: 'Adicionar Região'
  },
  '编辑子推荐位地区': {
    zh: '编辑子推荐位地区',
    en: 'Edit Region',
    ar: 'تعديل المنطقة',
    fa: 'ویرایش منطقه',
    pt: 'Editar Região'
  },
  '请先编辑子推荐位地区': {
    zh: '请先编辑子推荐位地区',
    en: 'Please edit a region first.',
    ar: 'يرجى تحرير المنطقة الفرعية الموصى بها.',
    fa: 'لطفا اول منطقه‌ی مکان زیر پیشنهاد را ویرایش کنید.',
    pt: 'Edite primeiro a área de subrecomendação'
  },
  '添加计划': {
    zh: '添加计划',
    en: 'Plan',
    ar: 'إضافة خطة',
    fa: 'افزودن برنامه',
    pt: 'Adicionar Plano'
  },
  '推荐位内容名称': {
    zh: '推荐位内容名称',
    en: 'Content Name',
    ar: 'اسم المحتوى',
    fa: 'نام محتویات',
    pt: 'Nome do Conteúdo'
  },
  '运营国家': {
    zh: '运营国家',
    en: 'Region',
    ar: 'البلد',
    fa: 'کشور',
    pt: 'Região'
  },
  '推荐方式': {
    zh: '推荐方式',
    en: 'Classification',
    ar: 'تصنيفات',
    fa: 'طبقه بندی',
    pt: 'Método Recomendado'
  },
  '显示周期': {
    zh: '显示周期',
    en: 'Run Time',
    ar: 'وقت التشغيل',
    fa: 'زمان اجرا',
    pt: 'Ciclo de Exibição'
  },
  '启动': {
    zh: '启动',
    en: 'Open',
    ar: 'بدء',
    fa: 'شروع',
    pt: 'Abrir'
  },
  '执行时间': {
    zh: '执行时间',
    en: 'Run Time',
    ar: 'وقت التشغيل',
    fa: 'زمان اجرا',
    pt: 'Tempo de Execução'
  },
  '不限': {
    zh: '不限',
    en: 'All',
    ar: 'لا حدود',
    fa: 'هیچ محدودیت',
    pt: 'Ilimitado'
  },
   '不限_default': {
    zh: '不限',
    en: 'Default',
    ar: 'افتراضي',
    fa: 'پیش‌فرض',
    pt: 'Padrão'
  },
  '运营计划': {
    zh: '运营计划',
    en: 'Plan',
    ar: 'مخطط',
    fa: 'نقشه',
    pt: 'Plano Operacional'
  },
  '添加运营计划': {
    zh: '添加计划',
    en: 'Add Plan',
    ar: 'إضافة خطة',
    fa: 'افزودن برنامه',
    pt: 'Adicione Plano'
  },
  '预览': {
    zh: '预览',
    en: 'Preview',
    ar: 'معاينة',
    fa: 'پیش‌نمایش',
    pt: 'Visualização'
  },
  '运营主题设置': {
    zh: '运营主题设置',
    en: 'Topic Settings',
    ar: 'إعدادات الموضوع',
    fa: 'تنظیمات عنوان',
    pt: 'Configurações de Tópicos'
  },
  '主题设置': {
    zh: '主题设置',
    en: 'Topic Settings',
    ar: 'إعدادات الموضوع',
    fa: 'تنظیمات عنوان',
    pt: 'Configurações de Tópicos'
  },
  '执行周期': {
    zh: '执行周期',
    en: 'Run Time',
    ar: 'وقت التشغيل',
    fa: 'زمان اجرا',
    pt: 'Ciclo de Execução'
  },
  '背景图': {
    zh: '背景图',
    en: 'Background Image',
    ar: 'خلفية الصورة',
    fa: 'تصویر زمینه',
    pt: 'Imagem de Fundo'
  },
  '添加主题': {
    zh: '添加主题',
    en: 'Add Topic',
    ar: 'إضافة مواضيع',
    fa: 'افزودن عنوان',
    pt: 'Adicionar Tópico'
  },
  '复制主题': {
    zh: '复制主题',
    en: 'Copy Topic',
    ar: 'نسخ الموضوع',
    fa: 'موضوع را کپی کنید',
    pt: 'Copiar Tópico'
  },
  '时间设置': {
    zh: '时间设置',
    en: 'Run Time',
    ar: 'وقت التشغيل',
    fa: 'زمان اجرا',
    pt: 'Configuração de Tempo'
  },
  '主题背景图': {
    zh: '主题背景图',
    en: 'Topic Background',
    ar: 'خلفية الموضوع',
    fa: 'زمینه‌ی عنوان',
    pt: 'Plano de Fundo Tópico'
  },
  'recommend_s': {
    zh: '推荐',
    en: 'Recommend',
    ar: 'التوصية',
    fa: 'پیشنهاد کنید',
    pt: 'Recomendar'
  },
  'movie_s': {
    zh: '电影',
    en: 'Movies',
    ar: 'فيلم',
    fa: 'فیلم سینما',
    pt: 'Filmes'
  },
  'series_s': {
    zh: '电视剧',
    en: 'TV Shows',
    ar: 'دراما تلفزيونية',
    fa: 'درام تلویزیونی',
    pt: 'Programas Televisão'
  },
  'category_s': {
    zh: '分类',
    en: 'Category',
    ar: 'تصنيف',
    fa: 'دسته بندی',
    pt: 'classificação'
  },
  'discover_s': {
    zh: '其他',
    en: 'Discover',
    ar: 'أخرى',
    fa: 'دیگر',
    pt: 'Descobrir'
  },
  '主题内容类型': {
    zh: '主题内容类型',
    en: 'Content Type',
    ar: 'نوع محتوای موضوع',
    fa: 'موضوع نوع المحتوى',
    pt: 'Tipo de Conteúdo'
  },
  '请选择主题内容类型': {
    zh: '请选择主题内容类型',
    en: 'Please select the content Type',
    ar: 'الرجاء اختيار موضوع نوع المحتوى',
    fa: 'لطفا یک نوع محتوای موضوع را انتخاب کنید',
    pt: 'Selecione o tipo de conteúdo'
  },
  '影片列表': {
    zh: '影片列表',
    en: 'Movie List',
    ar: 'قائمة الأفلام',
    fa: 'فهرست فیلم',
    pt: 'Lista de Filmes'
  },
  '剧集列表': {
    zh: '剧集列表',
    en: 'TV Shows List',
    ar: 'قائمة المسلسلات التلفزيونية',
    fa: 'فهرست سری تلویزیون',
    pt: 'Lista de Programas TV'
  },
  '选择分类': {
    zh: '选择分类',
    en: 'Category',
    ar: 'تصنيفات',
    fa: 'طبقه بندی',
    pt: 'Categoria'
  },
  '请选择分类': {
    zh: '请选择分类',
    en: 'Please select a category',
    ar: 'الرجاء اختيار الفئة',
    fa: 'لطفا یک نوع را انتخاب کنید',
    pt: 'Por favor, selecione uma categoria'
  },
  '输入不能为空格': {
    zh: '输入不能为空格',
    en: 'Input cannot be a space',
    ar: 'لا يمكن إدخال فارغة',
    fa: 'ورودی نمی تواند خالی باشد',
    pt: 'A entrada não pode ser um espaço'
  },
  '数据导入失败,请按下载文档校正再导入': {
    zh: '数据导入失败,请按下载文档校正再导入',
    en: 'Import failed. Please press the download document to correct before importing.',
    ar: 'فشل استيراد البيانات ، اضغط على تحميل الوثيقة لتصحيح استيراد مرة أخرى .',
    fa: 'واردات شکست خورد. لطفا درست کنید و دوباره امتحان کنید.',
    pt: 'A importação de dados falhou, corrija de acordo com o documento de download antes de importar novamente.'
  },
  '创建主品牌': {
    zh: '创建主品牌',
    en: 'Create Main Brand',
    ar: 'إنشاء العلامة التجارية الرئيسية',
    fa: 'برند اصلی ایجاد کنید',
    pt: 'Crie uma Marca Mestre'
  },
  '您还没有主品牌，点击 “创建” 按钮创建。': {
    zh: '您还没有主品牌，点击 “创建” 按钮创建。',
    en: 'You do not have a main brand yet. Click the \'Create\' button to create it.',
    ar: 'لم يكن لديك العلامة التجارية الرئيسية ، انقر على زر إنشاء لإنشاء .',
    fa: 'شما هیچ مارک اصلی ندارید ، برای ایجاد بر روی دکمه \'ایجاد\' کلیک کنید.',
    pt: 'Você ainda não tem uma marca master, clique no botão “Criar” para criar uma.'
  },
  '您还没有子品牌，点击 “创建” 按钮创建。': {
    zh: '您还没有子品牌，点击 “创建” 按钮创建。',
    en: 'You do not have any sub brands yet. Click the \'Create\' button to create them.',
    ar: 'لم يكن لديك العلامة التجارية الفرعية ، انقر على زر إنشاء لإنشاء .',
    fa: 'هنوز هیچ برند زیر ندارید. برای ایجاد آنها دکمه \'ایجاد\' را فشار دهید.',
    pt: 'Você ainda não tem uma submarca, clique no botão “Criar” para criar uma.'
  },
  '创建子品牌': {
    zh: '创建子品牌',
    en: 'Create Sub Brand',
    ar: 'خلق',
    fa: 'ایجاد کنید',
    pt: 'Crie uma submarca'
  },
  '创建子品牌_c': {
    zh: '创建子品牌',
    en: 'Create',
    ar: 'خلق',
    fa: 'ایجاد کنید',
    pt: 'Criar'
  },
  '创建主品牌_c': {
    zh: '创建主品牌',
    en: 'Create',
    ar: 'خلق',
    fa: 'ایجاد کنید',
    pt: 'Criar'
  },
  '编辑主品牌': {
    zh: '编辑主品牌',
    en: 'Edit Main Brand',
    ar: 'تحرير',
    fa: 'ویرایش',
    pt: 'Editar Marca Principal'
  },
  '编辑子品牌': {
    zh: '编辑子品牌',
    en: 'Edit Sub Brand',
    ar: 'تحرير',
    fa: 'ویرایش',
    pt: 'Editar Sub Marcas'
  },
  '复制子品牌': {
    zh: '复制子品牌',
    en: 'Copy Sub Brand',
    ar: 'ينسخ',
    fa: 'کپی',
    pt: 'Copiar Sub Marcas'
  },
  '关联后两个子品牌修改自动同步': {
    zh: '关联后两个子品牌修改自动同步',
    en: 'Automatically synchronize and modify the two sub brands after association.',
    ar: 'بعد ارتباط اثنين من العلامات التجارية الفرعية تلقائيا تعديل متزامن.',
    fa: 'پس از ارتباط ، دو زیر بند به طور خودکار همزمان می شوند.',
    pt: 'Após a associação, os dois sub -marcas modificam a sincronização automática.'
  },
  '选择主品牌': {
    zh: '选择主品牌',
    en: 'Select Main Brand',
    ar: 'اختيار العلامة التجارية الرئيسية',
    fa: 'مارک اصلی را انتخاب کنید',
    pt: 'Escolha a marca principal'
  },
  '是否关联': {
    zh: '是否关联',
    en: 'Associated',
    ar: 'مترابط',
    fa: 'ارتباط',
    pt: 'Associado'
  },
  '确认将内容移除子品牌, 移除后内容关联子品牌的其他分类也会将内容移除。': {
    zh: '确认将内容移除子品牌, 移除后内容关联子品牌的其他分类也会将内容移除。',
    en: 'Confirm to remove the content from the sub brand, and other categories associated with the sub brand will also remove the content after removal.',
    ar: ' تأكد من إزالة محتوى العلامة التجارية الفرعية ، وغيرها من الفئات المرتبطة محتوى العلامة التجارية الفرعية أيضا إزالة المحتوى بعد إزالة .',
    fa: 'تأیید کنید که محتوای محتوا برداشته شده است ، و سایر دسته از محتوای مرتبط با زیربند پس از حذف نیز محتوا را حذف می کنند.',
    pt: 'Confirme se o conteúdo será removido da submarca. Após a remoção, o conteúdo também será removido de outras categorias associadas à submarca.'
  },
  '解除关联': {
    zh: '解除关联',
    en: 'Disassociation',
    ar: 'فك الارتباط',
    fa: 'آزاد',
    pt: 'Desassociar'
  },
  '解除关联后，两个子品牌之间做任何修改将不再自动同步，确认解除关联?': {
    zh: '解除关联后，两个子品牌之间做任何修改将不再自动同步，确认解除关联?',
    en: 'After disassociation, any modifications made between the two sub brands will no longer be automatically synchronized. Confirm to disassociate?',
    ar: 'بعد فك الارتباط ، أي تغييرات بين اثنين من العلامات التجارية الفرعية لن تكون متزامنة تلقائيا ، تأكيد فك الارتباط ?',
    fa: 'بعد از نابودی، هر تغییرات بین دو برند زیر ساخته شده دیگر به طور خودکار همزمان نخواهد شد. باید به نابودی ثابت کنید?',
    pt: 'Após a desassociação, quaisquer modificações feitas entre as duas submarcas não serão mais sincronizadas automaticamente. Tem certeza de que deseja desassociar?'
  },
  '子品牌作为主关联并且已经关联其他子品牌，不可以删除，需要解除关联后再支持删除。': {
    zh: '子品牌作为主关联并且已经关联其他子品牌，不可以删除，需要解除关联后再支持删除。',
    en: 'The sub brand, as the main association and already associated with other sub brands, cannot be deleted and needs to be disassociated before deletion.',
    ar: 'العلامات التجارية الفرعية الرئيسية المرتبطة بالفعل مع غيرها من العلامات التجارية الفرعية ، لا يمكن حذفها ، تحتاج إلى إزالة الارتباط قبل حذفها.',
    fa: 'برند زیر، به عنوان اتصال اصلی و قبل از حذف کردن با برندهای زیر دیگر، نمی تواند حذف شود و باید قبل از حذف جدا شوند.',
    pt: 'Uma submarca é a associação principal e já está associada a outras submarcas. Ela não pode ser excluída. Ela precisa ser desassociada antes que a exclusão seja permitida.'
  },
  '二级分类显示': {
    zh: '二级分类显示',
    en: 'Show Second Category',
    ar: 'عرض الفئة الثانية',
    fa: 'نمایش دسته دوم',
    pt: 'Mostrar segunda categoria'
  },
  'Ecos UI 风格': {
    zh: 'Ecos UI 风格',
    en: 'Ecos UI Style',
    ar: 'نمط واجهة المستخدم البيئية',
    fa: 'Ecos UI Style',
    pt: 'Estilo de UI Ecos'
  },
  '定制主品牌删除后，终端将不再显示定制主品牌下的所有子品牌，确定删除吗？': {
    zh: '定制主品牌删除后，终端将不再显示定制主品牌下的所有子品牌，确定删除吗？',
    en: 'After deleting the customized main brand, the terminal will no longer display all sub-brands under the customized main brand. Are you sure you want to delete it?',
    ar: 'بعد حذف العلامة التجارية الرئيسية المخصصة، لن يعرض الجهاز بعد ذلك جميع العلامات التجارية الفرعية ضمن العلامة التجارية الرئيسية المخصصة. هل أنت متأكد من حذفها؟',
    fa: 'پس از حذف نام تجاری اصلی سفارشی شده، ترمینال دیگر همه مارک های فرعی را تحت نام تجاری اصلی سفارشی نشان نمی دهد آیا مطمئن هستید که آن را حذف می کنید؟',
    pt: 'Após a eliminação da marca principal personalizada, o terminal deixará de apresentar todas as submarcas da marca principal personalizada.'
  },

  '影片评分': {
    zh: '影片评分',
    en: 'Film Rating',
    ar: 'تقييم الفيلم (Taqyeem al-Film)',
    fa: 'امتیاز فیلم (Emtiyaz-e Film)',
  },
  '影片热度': {
    zh: '影片热度',
    en: 'Film Popularity',
    ar: 'شعبية الفيلم (Shabiyat al-Film)',
    fa: 'محبوبیت فیلم (Mahboobiyat-e Film)',
  },

  '分类1-终端名称': {
    zh: '分类1-终端名称',
    en: 'Category 1 - Terminal Name',
    ar: 'الفئة 1 - اسم المحطة',
    fa: 'دسته 1 - نام ترمینال',
    pt: 'Categoria 1 - Nome do Terminal',
  },
  '分类2-终端名称': {
    zh: '分类2-终端名称',
    en: 'Category 2 - Terminal Name',
    ar: 'الفئة 2 - اسم المحطة',
    fa: 'دسته 2 - نام ترمینال',
    pt: 'Categoria 2 - Nome do Terminal',
  },
  '关联的第二个分类在终端显示的名称,关联填写,未关联无须填写': {
    zh: '关联的第二个分类在终端显示的名称,关联填写,未关联无须填写',
    en: 'The name of the second associated category displayed on the terminal (fill in if associated, leave blank if not associated)',
    ar: 'اسم الفئة الثانية المرتبطة المعروضة على المحطة (املأ إذا كانت مرتبطة، اترك فارغًا إذا لم تكن مرتبطة)',
    fa: 'نام دسته دوم مرتبط که در ترمینال نمایش داده می‌شود (در صورت مرتبط بودن پر کنید، در صورت عدم ارتباط خالی بگذارید)',
    pt: 'O nome da segunda categoria associada exibida no terminal (preencha se associado, deixe em branco se não estiver associado)',
  },
  '推荐顺序': {
    zh: '推荐顺序',
    en: 'Recommended Order',
    ar: 'ترتيب موصى به',
    fa: 'ترتیب توصیه شده',
    pt: 'Ordem Recomendada',
  },
  '分类终端名称': {
    zh: '分类终端名称',
    en: 'Category Terminal Name',
    ar: 'اسم محطة التصنيف',
    fa: 'نام ترمینال دسته‌بندی',
    pt: 'Nome do Terminal da Categoria',
  },
  '多语言编辑': {
    zh: '多语言编辑',
    en: 'Multilingual Editing',
    ar: 'تحرير متعدد اللغات',
    fa: 'ویرایش چند زبانه',
    pt: 'Edição Multilíngue',
  },
  '请输入终端名称': {
    zh: '请输入终端名称',
    en: 'Please enter the terminal name',
    ar: 'الرجاء إدخال اسم المحطة',
    fa: 'لطفاً نام ترمینال را وارد کنید',
    pt: 'Por favor, insira o nome do terminal',
  },
  '选择属性': {
    zh: '选择属性',
    en: 'Select Attribute',
    ar: 'اختر الخاصية',
    fa: 'انتخاب ویژگی',
    pt: 'Selecionar Atributo',
  },
  '属性': {
    zh: '属性',
    en: 'Attribute',
    ar: 'خاصية',
    fa: 'ویژگی',
    pt: 'Atributo',
  },
  '已选属性': {
    zh: '已选属性',
    en: 'Selected Attribute',
    ar: 'الخاصية المختارة',
    fa: 'ویژگی انتخاب شده',
    pt: 'Atributo Selecionado',
  },
  '勾选需要排序的属性,选取的属性将排在列表前列': {
    zh: '勾选需要排序的属性,选取的属性将排在列表前列',
    en: 'Check the attributes that need to be sorted; the selected attributes will be listed at the top.',
    ar: 'حدد السمات التي تحتاج إلى ترتيب؛ السمات المختارة ستظهر في مقدمة القائمة.',
    fa: 'ویژگی‌هایی که نیاز به مرتب‌سازی دارند را علامت بزنید؛ ویژگی‌های انتخاب شده در ابتدای لیست قرار خواهند گرفت.',
    pt: 'Marque os atributos que precisam ser ordenados; os atributos selecionados aparecerão no topo da lista.',
  },
  '选择系列片分类': {
    zh: '选择系列片分类',
    en: 'Select Series Classification',
    ar: 'اختر تصنيف السلسلة',
    fa: 'انتخاب دسته‌بندی سریال',
    pt: 'Selecionar Classificação da Série',
  },
  '主题方式': {
    zh: '主题方式',
    en: 'Thematic Approach',
    ar: 'نهج موضوعي',
    fa: 'رویکرد موضوعی',
    pt: 'Abordagem Temática',
  },
  '模板控件': {
    zh: '模板控件',
    en: 'Template Control',
    ar: 'تحكم القالب',
    fa: 'کنترل قالب',
    pt: 'Controle de Modelo',
  },
  '模板编辑器': {
    zh: '模板编辑器',
    en: 'Template Editor',
    ar: 'محرر القوالب',
    fa: 'ویرایشگر قالب',
    pt: 'Editor de Modelo',
  },
  '静态': {
    zh: '静态',
    en: 'Static',
    ar: 'ثابت',
    fa: 'استاتیک',
    pt: 'Estático',
  },
  '动态': {
    zh: '动态',
    en: 'Dynamic',
    ar: 'ديناميكي',
    fa: 'پویا',
    pt: 'Dinâmico',
  },
  '模板主内容分类，点击添加按钮可以新增子分类': {
    zh: '模板主内容分类，点击添加按钮可以新增子分类',
    en: 'Template main content categories. Click the add button to create new subcategories',
    ar: 'فئات المحتوى الرئيسية للنموذج. انقر فوق زر الإضافة لإنشاء فئات فرعية جديدة',
    fa: 'دسته‌بندی‌های محتوای اصلی قالب. برای ایجاد زیردسته‌های جدید روی دکمه افزودن کلیک کنید',
    pt: 'Categorias principais de conteúdo do modelo. Clique no botão adicionar para criar novas subcategorias',
  },
  '分类显示在横版左侧分类ALL下方，根据添加顺序排序': {
    zh: '分类显示在横版左侧分类ALL下方，根据添加顺序排序',
    en: 'Categories are displayed on the left side of the horizontal layout under the "ALL" category, sorted according to the order of addition.',
    ar: 'يتم عرض الفئات على الجانب الأيسر من التخطيط الأفقي تحت فئة "ALL"، وتم فرزها وفقًا لترتيب الإضافة',
    fa: 'دسته‌ها در سمت چپ طرح افقی زیر دسته‌بندی "ALL" نمایش داده می‌شوند و بر اساس ترتیب افزوده شدن مرتب شده‌اند',
    pt: 'As categorias são exibidas no lado esquerdo do layout horizontal, abaixo da categoria "TODAS", ordenadas de acordo com a ordem de adição',
  },
  '广告地址': {
    zh: '广告地址',
    en: 'Advertising Address',
    ar: 'عنوان الإعلان',
    fa: 'آدرس تبلیغات',
    pt: 'Endereço de publicidade'
  },
  '宽度': {
    zh: '宽度',
    en: 'Width',
    ar: 'العرض',
    fa: ' عرض',
    pt: 'Largura'
  },
  '高度': {
    zh: '高度',
    en: 'Height',
    ar: 'الارتفاع',
    fa: 'ارتفاع',
    pt: 'Altura'
  },
  '广告贴片': {
    zh: '广告贴片',
    en: 'Ad-Lite',
    ar: 'Ad-Lite',
    fa: 'Ad-Lite',
    pt: 'Ad-Lite'
  },
  '小标题': {
    zh: '小标题',
    en: 'Subheading',
    ar: 'عنوان فرعي',
    fa: 'زیرعنوان',
    pt: 'Subtítulo',
  },
  '开': {
    zh: '开',
    en: 'Open',
    ar: 'ابدأ',
    fa: 'شروع کن',
    pt: 'Abrir',
  },
  '关': {
    zh: '关',
    en: 'Close',
    ar: 'اطفئ',
    fa: 'خاموش کن',
    pt: 'Fechar',
  },
  '推荐位图': {
    zh: '推荐位图',
    en: 'Image Type',
    ar: 'نوع الصورة',
    fa: 'نوع تصویر',
    pt: 'Tipo de Imagem',
  },
  '推荐位数': {
    zh: '推荐位数',
    en: 'Item Count',
    ar: 'عدد العناصر',
    fa: 'تعداد آیتم‌ها',
    pt: 'Contagem de Itens',
  },
  '分类+更多': {
    zh: '分类+更多',
    en: 'Categories + More',
    ar: 'تصنيفات + المزيد',
    fa: 'دسته‌بندی‌ها + بیشتر',
    pt: 'Categorias + Mais',
  },
  '分类数': {
    zh: '分类数',
    en: 'Category Count',
    ar: 'عَدَدُ الفِئَات',
    fa: 'عدد الأقسام',
    pt: 'Contagem de Categorias',
  },
  '子分类': {
    zh: '子分类',
    en: 'Subcategory',
    ar: 'تصنيف فرعي',
    fa: 'زیردسته',
    pt: 'Subcategoria',
  },
  '终端名称': {
    zh: '终端名称',
    en: 'Terminal Name',
    ar: 'اسم الجهاز الطرفي',
    fa: 'نام ترمینال',
    pt: 'Nome do Terminal',
  },
  '智能推荐': {
    zh: '智能推荐',
    en: 'Smart Recommend',
    ar: 'توصية ذكية',
    fa: 'توصیه ذکیر',
    pt: 'Recomendação Inteligente',
  },
  '推荐配置': {
    zh: '推荐配置',
    en: 'Recommend Configuration',
    ar: 'تنظيمات التوصية',
    fa: 'تنظیمات توصیه',
    pt: 'Configuração de Recomendação',
  },
  '开启后根据智能配置信息，每周自动更新一次推荐位内容': {
    zh: '开启后根据智能配置信息，每周自动更新一次推荐位内容',
    en: 'After activation, the recommended content will be automatically updated once a week based on the intelligent configuration information.',
    ar: 'بعد التمكين، سيتم تحديث محتوى التوصية تلقائياً مرة واحدة في الأسبوع بناءً على معلومات التكوين الذكي.',
    fa: 'پس از فعال‌سازی، محتوای توصیه‌ای تلقائیاً یک بار در هفته بر اساس اطلاعات تنظیم ذکیر به روز می‌شود.',
    pt: 'Após a ativação, o conteúdo recomendado será atualizado automaticamente uma vez por semana com base nas informações de configuração inteligente.',
  },
  '切片时长': {
    zh: '切片时长',
    en: 'Segment Duration',
    ar: 'مدة القطعة',
    fa: 'مدت آیتم',
    pt: 'Duração do Segmento',
  },
  '起始切片序号': {
    zh: '起始切片序号',
    en: 'Starting Segment Number',
    ar: 'رقم القطعة الابتدائية',
    fa: 'شماره قطعه اولیه',
    pt: 'Número do Segmento Inicial',
  },
  'DASH分片日志': {
    zh: 'DASH分片日志',
    en: 'DASH Segment Log',
    ar: 'سجل قطعة DASH',
    fa: 'لاگ قطعه DASH',
    pt: 'Log de Segmento DASH',
  },
  '归属模式': {
    zh: '归属模式',
    en: 'Belonging Mode',
    ar: 'نوع تعیین محل',
    fa: 'نوع تعیین محل',
    pt: 'Tipo de Determinação de Localização',
  },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },
}